// Lifted from useNineSegmentsTableColumns; pure so basic-output can reuse without React/Jotai.

import * as R from 'remeda'

import {
  type ColumnInfo,
  compact,
  mapNineSegment,
  reversedNineSegments,
} from '~/utils'

import {
  type NineSegmentColumnKey as ColumnKey,
  nineSegmentIndicators,
} from './nineSegments'

const widthMap: Record<ColumnKey, string> = {
  brandNumber: 'max-content',
  brandName: 'max-content',
  ...mapNineSegment(() => '6em'),
  indicatorPad: '0.5rem',
  ...R.mapToObj(nineSegmentIndicators, (indicator) => [indicator, '8em']),
}

export const buildNineSegmentsTableColumns = ({
  hiddenColumnKeys,
}: {
  hiddenColumnKeys: ReadonlyArray<ColumnKey>
}): ColumnInfo<ColumnKey>[] => {
  const visibleNineSegments = R.difference(
    reversedNineSegments,
    hiddenColumnKeys,
  )
  const visibleIndicators = R.difference(
    nineSegmentIndicators,
    hiddenColumnKeys,
  )

  const hasIndicatorPad =
    0 < visibleNineSegments.length && 0 < visibleIndicators.length

  const columnKeys: ColumnKey[] = compact([
    'brandNumber',
    'brandName',
    ...visibleNineSegments,
    hasIndicatorPad && 'indicatorPad',
    ...visibleIndicators,
  ])

  return columnKeys.map((key) => ({ key, width: widthMap[key] }))
}
